// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import BookAppointmentPage from "../pages/BookAppointment/BookAppointment";
const __wvcRoutePaths = ["/BookAppointmentPage", "/book-appointment"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["book-appointment", "bookappointmentpage", "home", "homepage", "manager-profile", "managerprofilepage", "post", "project-gallery", "projectgallerypage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<BookAppointmentPage />} />
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<BookAppointmentPage />} />
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
